// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Injectable, Repository, ResourceActionFailed } from '@movecloser/front-core';
import { resolveFromStatus } from '@exception/connector-errors';
let ReactionsRepository = class ReactionsRepository extends Repository {
    constructor() {
        super(...arguments);
        this.map = {};
    }
    async toggleLike(type, id) {
        var _a;
        const response = await this.connector.call('reactions', 'toggle', {}, { type, id, reactionType: 'like' });
        if (!response.isSuccessful()) {
            throw new ResourceActionFailed((_a = response.errors) === null || _a === void 0 ? void 0 : _a.message, resolveFromStatus(response), response.data.errors);
        }
        return response.data.data;
    }
};
ReactionsRepository = __decorate([
    Injectable()
], ReactionsRepository);
export { ReactionsRepository };
